import type { EnergyAnalysisCategoryTotal, EnergyAnalysisTotalChartType } from "../model/types";

import { ENERGY_ANALYSIS_TOTAL_CHART_TYPE } from "../model/constants";
import { buildCategoryBarOption } from "./buildCategoryBarOption";
import { buildDoughnutOption } from "./buildDoughnutOption";

export const buildTotalChartOption = (
  categoryTotals: EnergyAnalysisCategoryTotal[],
  chartType: EnergyAnalysisTotalChartType,
  snapshotValueMax?: number
) => {
  if (chartType === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.doughnut) return buildDoughnutOption(categoryTotals, "doughnut");
  return buildCategoryBarOption(
    categoryTotals,
    chartType === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.barHorizontal,
    snapshotValueMax
  );
};
